import React, { Component, Fragment } from 'react';
import { Card, CardBody } from 'reactstrap';

import ResponseBlockGenerator from '../components/ResponseBlockGenerator';
import { gAPI_Property_Facilities } from '../../../../../constants/APIs';

export default class PropertyFacilities extends Component {
  render() {
    return (
      <Fragment>
        <Card>
          <CardBody>
            <ResponseBlockGenerator getUrl={gAPI_Property_Facilities} />
          </CardBody>
        </Card>
      </Fragment>
    );
  }
}
